import { render, staticRenderFns } from "./RiskAssessmentMeasuresReduction.vue?vue&type=template&id=b8f55b70&scoped=true&"
import script from "./RiskAssessmentMeasuresReduction.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentMeasuresReduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f55b70",
  null
  
)

export default component.exports